import React, { useState } from "react";
import { Layout, Tabs, Grid } from "antd";
import AppHeader from "../components/Header";
import Master_Device from "../components/Tabs/Master_Device";
import DeviceOperations from "../components/Tabs/DeviceOperations";
import SettingTab from "../components/Tabs/SettingTab";
import Master_LoginUser from "../components/Tabs/Master_LoginUser";
import Master_Contract from "../components/Tabs/Master_Contract";
import "../styles/global.css";

const { Content } = Layout;
const { useBreakpoint } = Grid;

/**
 * CareTablet 管理画面トップメニュー
 * デバイス管理・デバイス操作・共通設定
 */
const TopMenu: React.FC = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [activeTab, setActiveTab] = useState<string>("1");

  const tabItems = [
    { key: "1", label: "デバイス管理", children: <Master_Device /> },
    { key: "2", label: "デバイス操作", children: <DeviceOperations /> },
    { key: "3", label: "ユーザー管理", children: <Master_LoginUser /> },
    { key: "4", label: "管理者登録履歴", children: <Master_Contract /> },
    { key: "5", label: "全デバイス共通設定", children: <SettingTab /> },
  ];

  return (
    <Layout style={{ minHeight: "100vh", width: "100%" }}>
      <AppHeader />
      <Content style={{ padding: isMobile ? "8px" : "16px", minWidth: 0, width: "100%" }}>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          centered={!isMobile}
          size={isMobile ? "small" : "middle"}
          tabBarGutter={isMobile ? 8 : undefined}
          items={tabItems}
        />
      </Content>
    </Layout>
  );
};

export default TopMenu;
